import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "changing-number" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_ctx.number !== undefined)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.number.toFixed(_ctx.precision)), 1))
      : _createCommentVNode("", true)
  ]))
}